<template>
  <progress-bar
    @quit="$emit('quit')"
    v-if="hasProgressComponent"
    :image-source="levelComponent.progress"
  />
  <scrollable-content :wide="!hasProgressComponent">
    <div class="flex flex-col items-center">
      <div class="mt-4">
        <img
          class="max-w-xs max-h-xs"
          :src="currentAdvisorPath">
      </div>
      <div
        v-if="levelComponent.options.header"
        v-html="$t(levelComponent.options.header)"
        class="mt-2 text-center px-6 text-xl text-ctm-primary uppercase"
      />
      <div
        v-html="$t(getAdvisorWelcomeText)"
        class="mt-6 text-center px-6 text-base text-ctm-black"
      />
      <div class="my-6 flex flex-col">
        <button
          :key="index"
          :class="{
            'mt-2': true,
            'button': true,
            'button-default': index === 0,
            'button-outline': index > 0
          }"
          @click.prevent="performAction(answer)"
          v-for="(answer, index) in levelComponent.options.answers">
          {{ $t(answer.text) }}
        </button>
      </div>
    </div>
  </scrollable-content>
</template>

<script>
  import {mapGetters} from "vuex"

  export default {
    computed: {
      ...mapGetters({
        advisorIcon: 'advisorIcon',
        advisorIcons: 'advisorIcons',
      }),
      currentAdvisorPath() {
        let currentAdvisor = this.advisorIcon
        if (currentAdvisor) {
          let ca = this.advisorIcons.find(advisor => advisor.id === currentAdvisor)
          if (ca) {
            return ca.iconBig
          }
        }
      },
      getAdvisorWelcomeText() {
        return `greetingScreen.${this.advisorIcon}`
      }
    },
    emits: [
      'setWindowMode',
      'quit'
    ]
  }
</script>